"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReportedReplies = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var getReportedReplies = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(publicId) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get('/unified/api/content', {
              params: {
                filters: {
                  state: ['reported'],
                  topicPublicIds: [publicId]
                }
              }
            });

          case 2:
            response = _context.sent;
            return _context.abrupt("return", {
              data: response.data.content,
              total: response.data.total
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getReportedReplies(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getReportedReplies = getReportedReplies;